<modern-layout [termsLink]="termsLink()" [buildInfo]="buildInfo"></modern-layout>
